export default __webpack_public_path__ + "static/media/xpensityV1-tablet-side.aea286b8.webp";